<template>
<b-overlay :show="showoverlay" rounded="sm">
<div class="employee-tab-inner contract-wizard-content">
  <div class="card-body container-fluid p-0">
  <b-form @submit.stop.prevent="onSubmit" >
            <b-card no-body class="border-0 bg-white no-shadow">
                    <template v-if="fdata">
                    <div class="clearfix row no-margin d-none" v-if="update_contract != 0">
                      <div class="col-md-6 d-flex align-items-center">
                       What information do you wish to update
                      </div>
                      <div class="col-md-6">
                        <b-form-select v-model="update_wizard" :options="wizard_options" @change="loadWizard()"></b-form-select>
                      </div>
                    </div>
                    <form-wizard ref="wizard" color="#43A047" @on-complete="onComplete">
                        <span class="py-2 mt-3 mb-4" slot="title"></span> 
                        <input type="hidden" v-model="fdata.employee_id" name="employee_id"/>
                        <input type="hidden" v-model="update_contract" name="contract_update"/>
                        <tab-content title="Overview" ref="tab_overview">
                        <div class="clearfix">
                            <b-form-group id="contract_start-group" label="Please enter contract start date" label-for="contract_start" class="my-2">
                                <b-form-datepicker id="contract_start" name="contract_start" v-model="fdata.contract_start" :aria-required="true" v-validate="{ required: true, min: 3,alpha_spaces: true}" :state="validateState('contract_start')" aria-describedby="contract_start-feedback" data-vv-as="Contract Start Date" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                <b-form-invalid-feedback id="contract_start">{{ veeErrors.first('contract_start') }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <b-form-group id="contract_end-group" label="Contract End Date" label-for="contract_end" >
                             <b-form-datepicker id="contract_end" name="contract_end" v-model="fdata.contract_end" reset-button></b-form-datepicker>
                             <b-form-invalid-feedback id="contract_end">{{ veeErrors.first('contract_end') }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <b-form-group id="probation_period-group" label="Probation Period?" label-for="probation_period" class="my-2 custom-radio clearfix">
                               
                                <div class="custom-control float-left mr-3">
                                    <input type="radio" id="prob_yes" class="custom-control-input" name="has_probation" value="1" v-model="fdata.has_probation" :disabled="isContractDisabled()"/>
                                    <label class="custom-control-label" for="__BVID__239">Yes </label>
                                </div>
                                <div class="custom-control float-left">
                                    <input type="radio" id="prob_no"  class="custom-control-input" name="has_probation" value="0" v-model="fdata.has_probation" :disabled="isContractDisabled()"/>
                                    <label class="custom-control-label" for="__BVID__239">No </label>
                                </div>
                                <!--<b-form-checkbox id="has_probation"  v-model="fdata.has_probation" name="has_probation" value="1" unchecked-value="0" :disabled="isContractDisabled()">
                                   
                                </b-form-checkbox>-->
                            </b-form-group>
                            
                            <b-form-group id="probation_start-group" label="Probation Period Start Date" label-for="probation_start" v-if="fdata.has_probation==1" class="my-2">
                                <b-form-datepicker id="probation_start" name="probation_start" v-model="fdata.probation_start" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                            </b-form-group>
                            <b-form-group id="probation_end-group" label="Probation Period End Date" label-for="probation_end" v-if="fdata.has_probation==1" class="my-2">
                                <b-form-datepicker id="probation_end" name="probation_end" v-model="fdata.probation_end" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                            </b-form-group>
                            
                            <template v-if="fdata.has_probation == 1">
                                <b-form-group id="probation_gross_salary-group" label="Probation Gross Salary" label-for="probation_gross_salary">
                                    <b-form-input class="text-right max-200 " id="probation_gross_salary" name="probation_gross_salary" v-model="probation_salary['probation_gross_salary']" v-validate="{ required: true, min: 3 , decimal:3}" :state="validateState('probation_gross_salary')" aria-describedby="probation_gross_salary-feedback" data-vv-as="Probation Gross Salary" @input="triggerProbationGrossChange()" :disabled="isContractDisabled()"></b-form-input>
                                    <b-form-invalid-feedback id="probation_gross_salary-feedback">{{ veeErrors.first('probation_gross_salary') }}</b-form-invalid-feedback>
                                </b-form-group>
                                <b-form-group id="pb_optimized_salary_for_max_benefit-group" label="Do you want to optimize salary for maximum tax benefits?" label-for="pb_optimized_salary_for_max_benefit" class="my-2 custom-radio clearfix">
                                   <div class="custom-control float-left mr-3">
                                   <input type="radio" id="pb_optimized_yes" class="custom-control-input"  name="pb_optimized_salary_for_max_benefit" value="1" v-model="fdata.pb_optimized_salary_for_max_benefit" @input="optimizeProbationSalary(1)" :disabled="isContractDisabled()"/>
                                   <label class="custom-control-label">Yes </label>
                                   </div>
                                   <div class="custom-control float-left">
                                   <input type="radio" id="pb_optimized_no"  class="custom-control-input" name="pb_optimized_salary_for_max_benefit" value="0" v-model="fdata.pb_optimized_salary_for_max_benefit" :disabled="isContractDisabled()" @input="pb_salary_fields_editable=1"/>
                                   <label class="custom-control-label">No </label>
                                   </div>
                                    <!--<b-form-checkbox id=""  v-model="fdata.pb_optimized_salary_for_max_benefit" name="pb_optimized_salary_for_max_benefit" value="1" unchecked-value="0" @input="optimizeProbationSalary" :disabled="isContractDisabled()">
                                    </b-form-checkbox>-->
                                </b-form-group>
                                <template v-if="fdata.pb_optimized_salary_for_max_benefit == 0 || fdata.pb_optimized_salary_for_max_benefit == 1">
                                <template v-for="(pb_component,index)  in salary_settings.probation_data">
                                   <template v-if="pb_component.field_key !='probation_gross_salary'">
                                     <div class="col-md-6 max-200 float-left pl-0" v-bind:class="[index%2 ? 'pr-0' : '']">
                                     <b-form-group :id="pb_component.field_key+'-group'"  :label="pb_component.field_title" :label-for="pb_component.field_key">
                                       <b-form-input class="text-right max-200 " :id="pb_component.field_key" :name="'contract_field_'+pb_component.id" v-model="probation_salary[pb_component.field_key]" v-validate="{ required: true, min: 3 , decimal:3 }"  :aria-describedby="'contract_field_'+pb_component.id+'-feedback'" :data-vv-as="pb_component.field_title" @input="checkProbationGrossSalary(pb_component.field_key)" :disabled="isContractDisabled() || !pb_salary_fields_editable"></b-form-input>
                                       <b-form-invalid-feedback :id="'contract_field_'+pb_component.id+'-feedback'">{{ veeErrors.first('contract_field_'+pb_component.id) }}</b-form-invalid-feedback>
                                     </b-form-group>
                                     </div>
                                   </template>
                                </template>
                                </template>
                                
                            </template>
                            
                            <b-form-group id="pf_entitlement_selection-group" label="Do you wish to enroll this employee to the Provident Fund scheme?" label-for="pf_entitlement_selection" class="my-2 custom-radio clearfix">
                                    <div class="custom-control float-left mr-3">
                                      <input type="radio" id="pf_entitlement_yes" class="custom-control-input"  name="pf_entitlement" value="1" v-model="pf_entitlement" :disabled="isContractDisabled()"/>
                                      <label class="custom-control-label">Yes </label>
                                    </div>
                                    <div class="custom-control float-left">
                                      <input type="radio" id="pf_entitlement_no" class="custom-control-input" name="pf_entitlement" value="0" v-model="pf_entitlement" :disabled="isContractDisabled()"/>
                                      <label class="custom-control-label">No </label>
                                    </div>
                                <!--<b-form-checkbox id="optimized_salary_for_max_benefit"  v-model="fdata.optimized_salary_for_max_benefit" name="optimized_salary_for_max_benefit" value="1" unchecked-value="0" @input="optimizeSalary" :disabled="isContractDisabled()">
                                </b-form-checkbox>-->
                            </b-form-group>
                            
                            <b-form-group id="pf_start-group" label="PF Entitlement Start Date" label-for="pf_start" class="my-2" v-if="pf_entitlement == 1">
                              <b-form-datepicker id="pf_start" name="pf_start" v-model="fdata.pf_start" :aria-required="true"  aria-describedby="pf_start-feedback" data-vv-as="PF Entitlement Start Date" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                              <b-form-invalid-feedback id="pf_start">{{ veeErrors.first('pf_start') }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <b-form-group id="pf_end-group" label="PF Entitlement End Date" label-for="pf_end" class="my-2" v-if="pf_entitlement == 1">
                             <b-form-datepicker id="pf_end" name="pf_end" v-model="fdata.contract_end" disabled="true" reset-button></b-form-datepicker>
                            </b-form-group>
                            
                            </div>
                          <div class="clearfix mb-2 pb-2 mt-3"><div class="col-md-6 float-left pl-0"><b-button type="button" variant="primary" @click="goBack()" disabled>Prev</b-button></div><div class="col-md-6 float-right text-right pr-0 save-btn"><b-button type="submit" variant="success" v-if="update_contract != 0" class="mr-3">Save</b-button><b-button type="button" variant="primary" @click="moveNext('1')">Next</b-button></div></div>
                        </tab-content>
                        <tab-content title="Salary Information" ref="tab_salary_info">
                            <b-form-group id="gross-group" label="Gross Salary" label-for="gross">
                                <b-form-input id="gross-display" class="text-right max-200 d-none" name="gross-display" v-on:change="changeMoneyFormate(fdata.gross_display)" v-model="fdata.gross_display" v-validate="{ required: false, min: 3}" :state="validateState('gross-display')" aria-describedby="gross-feedback-display" data-vv-as="Gross Salary" :disabled="isContractDisabled()"></b-form-input>
                                <b-form-input id="gross" class="text-right max-200 " name="gross" v-model="fdata.gross" v-validate="{ required: false, min: 3 , decimal:3}" :state="validateState('gross')" aria-describedby="gross-feedback" data-vv-as="Gross Salary" @input="triggerGrossChange()" :disabled="isContractDisabled()"></b-form-input>
                                <b-form-invalid-feedback id="gross-feedback">{{ veeErrors.first('gross') }}</b-form-invalid-feedback>
                                <b-form-invalid-feedback id="gross-feedback-display">{{ veeErrors.first('gross-display') }}</b-form-invalid-feedback>
                            </b-form-group>
        
                            <b-form-group id="optimized_salary_for_max_benefit-group" label="Do you want to optimize salary for maximum tax benefits?" label-for="optimized_salary_for_max_benefit" class="my-2 custom-radio clearfix">
                                <div class="custom-control float-left mr-3">
                                <input type="radio" id="optimized_yes" class="custom-control-input"  name="optimized_salary_for_max_benefit" value="1" v-model="fdata.optimized_salary_for_max_benefit" @input="optimizeSalary(1)" :disabled="isContractDisabled()"/>
                                <label class="custom-control-label">Yes </label>
                                </div>
                                <div class="custom-control float-left">
                                <input type="radio" id="optimized_no" class="custom-control-input" name="optimized_salary_for_max_benefit" value="0" v-model="fdata.optimized_salary_for_max_benefit" :disabled="isContractDisabled()" @input="salary_fields_editable=1"/>
                                <label class="custom-control-label">No </label>
                                </div>
                                <!--<b-form-checkbox id="optimized_salary_for_max_benefit"  v-model="fdata.optimized_salary_for_max_benefit" name="optimized_salary_for_max_benefit" value="1" unchecked-value="0" @input="optimizeSalary" :disabled="isContractDisabled()">
                                </b-form-checkbox>-->
                            </b-form-group>
                            <div class="clearfix salary-benefit-wrapper" v-if="fdata.optimized_salary_for_max_benefit == 0 || fdata.optimized_salary_for_max_benefit == 1">
                            <template v-for="(fixed_component,index)  in salary_settings.fixed">
                               <template v-if="fixed_component.field_key == 'basic_salary' || fixed_component.field_key == 'house_rent' || fixed_component.field_key == 'conveyance_allowance' || fixed_component.field_key == 'medical_allowance'">
                                     <div class="col-md-6 max-200 float-left pl-0"  v-bind:class="[index%2 ? 'pr-0' : '']">
                                     <b-form-group v-if="fixed_component.section_only != 1" :id="fixed_component.field_key+'-group'"  :label="fixed_component.field_title" :label-for="fixed_component.field_key">
                                            <b-form-input class="text-right max-200 " v-if="fixed_component.field_key == 'basic_salary'" :id="fixed_component.field_key" :name="'contract_field_'+fixed_component.id" v-model="component_values[fixed_component.field_name]"   v-validate="{ required: false }" :state="validateState('contract_field_'+fixed_component.id)" :aria-describedby="'contract_field_'+fixed_component.id+'-feedback'" :data-vv-as="fixed_component.field_title" @input="checkGrossSalary(fixed_component.field_key)" :disabled="isContractDisabled() || !salary_fields_editable"></b-form-input>
                                            <b-form-input class="text-right max-200 " v-else :id="fixed_component.field_key" :name="'contract_field_'+fixed_component.id" v-model="component_values[fixed_component.field_name]" v-validate="{ required: false }"  :aria-describedby="'contract_field_'+fixed_component.id+'-feedback'" :data-vv-as="fixed_component.field_title" @input="checkGrossSalary(fixed_component.field_key)" :disabled="isContractDisabled() || !salary_fields_editable"></b-form-input>
                                            <b-form-invalid-feedback :id="'contract_field_'+fixed_component.id+'-feedback'">{{ veeErrors.first('contract_field_'+fixed_component.id) }}</b-form-invalid-feedback>
                                     </b-form-group>
                                     </div>
                               </template>
                            </template>
                            </div>
                            
                            <template v-for="(fixed_component,index)  in salary_settings.fixed">
                             
                               <template v-if="fixed_component.field_key == 'other_monthly_allowance' && fixed_component.child_components">
                                <b-form-group label="Do you offer any other monthly allowance?" :label-for="fixed_component.field_key" class="my-2 custom-radio clearfix">
                                     <div class="custom-control float-left mr-3">
                                      <input type="radio" id="om_al_yes" class="custom-control-input" name="other_monthly_allowance_check" value="1" v-model="other_m_allowence"  :disabled="isContractDisabled()"/>
                                      <label class="custom-control-label">Yes </label>
                                     </div>
                                     <div class="custom-control float-left">
                                      <input type="radio" id="om_al_no" class="custom-control-input" name="other_monthly_allowance_check" value="0" v-model="other_m_allowence" :disabled="isContractDisabled()"/>
                                      <label class="custom-control-label">No </label>
                                     </div>
                                     <b-button v-if="other_m_allowence =='1'" variant="primary" id="show-btn" @click="selectChildComponents(fixed_component.field_name,fixed_component.field_title)" :disabled="isContractDisabled()" class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus" type="is-primary" variant="" scale="1"></b-icon> Add / Update</b-button>
                                </b-form-group>
                                 <template v-if="other_m_allowence =='1'">
                                  <template v-if="fixed_component.child_components">
                                     <template v-for="fixed_child  in fixed_component.child_components">
                                        <b-form-group v-if="fixed_child.is_checked == 1"  :label="fixed_child.field_title" :label-for="fixed_child.field_key" class="clearfix">
                                            <b-form-input class="text-right max-200 " :id="fixed_child.field_key" :name="'contract_field_'+fixed_child.id" v-model="component_values[fixed_child.field_key]"  v-validate="{ required: false }"  :aria-describedby="'contract_field_'+fixed_child.id+'-feedback'" :data-vv-as="fixed_child.field_title" :disabled="isContractDisabled()"></b-form-input>
                                            <b-form-invalid-feedback :id="'contract_field_'+fixed_child.id+'-feedback'">{{ veeErrors.first('contract_field_'+fixed_child.id) }}</b-form-invalid-feedback>
                                        </b-form-group>
                                     </template>
                                  </template>
                                 </template> 
                              </template>
                              
                              
                              <template v-if="fixed_component.field_key == 'conveyance_personal_private'">
                                <b-form-group  :label-for="fixed_component.field_key" label="Do you offer conveyance for personal/private use?" class="my-2 custom-radio clearfix">
                                    <!--<b-form-checkbox :id="'contract_field_date_range_'+fixed_component.id"  v-model="component_values[fixed_component.field_key]" :name="'contract_field_date_range_'+fixed_component.id" value="1" unchecked-value="0" v-validate="{ required: false }" @input="setDateRangeValue(fixed_component.field_key,$event)" :disabled="isContractDisabled()">
                                    </b-form-checkbox>-->
                                    <div class="custom-control float-left mr-3">
                                     <input type="radio" class="custom-control-input" :id="'contract_field_date_range_'+fixed_component.id"  :name="'contract_field_date_range_'+fixed_component.id" value="1" v-model="component_values[fixed_component.field_key]" @input="setDateRangeValue(fixed_component.field_key,$event)" v-validate="{ required: false }"  :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">Yes </label>
                                    </div>
                                    <div class="custom-control float-left">
                                     <input type="radio" class="custom-control-input" :id="'contract_field_date_range_'+fixed_component.id+'_1'" :name="'contract_field_date_range_'+fixed_component.id" value="0" v-model="component_values[fixed_component.field_key]" v-validate="{ required: false }"  :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">No </label>
                                    </div>
                                </b-form-group>
                                <b-form-group :id="fixed_component.field_key+'start-group'" label="Start Date" :label-for="fixed_component.field_key+'_start_date'" v-if="component_values[fixed_component.field_name] == 1">
                                    <b-form-datepicker :id="fixed_component.field_key+'_start_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].start.id" v-model="component_values[fixed_component.field_key+'_start_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                </b-form-group>
                               <b-form-group :id="fixed_component.field_key+'end-group'" label="End Date" :label-for="fixed_component.field_key+'_end_date'" v-if="component_values[fixed_component.field_name] == 1">
                                    <b-form-datepicker :id="fixed_component.field_key+'_end_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].end.id" v-model="component_values[fixed_component.field_key+'_end_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                </b-form-group>
                       
                              </template>
                              
                              <template v-if="fixed_component.field_key == 'rent_free_accommodation'">
                                   <b-form-group  :label-for="fixed_component.field_key" label="Do you offer rent-free accommodation?" class="my-2 custom-radio clearfix">
                                    <div class="custom-control float-left mr-3">
                                     <input type="radio" class="custom-control-input" :id="'contract_field_date_range_'+fixed_component.id"  :name="'contract_field_date_range_'+fixed_component.id" value="1" v-model="component_values[fixed_component.field_key]" @input="setDateRangeValue(fixed_component.field_key,$event)" v-validate="{ required: false }"  :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">Yes </label>
                                    </div>
                                    <div class="custom-control float-left">
                                     <input type="radio" class="custom-control-input" :id="'contract_field_date_range_'+fixed_component.id+'_1'" :name="'contract_field_date_range_'+fixed_component.id" value="0" v-model="component_values[fixed_component.field_key]" v-validate="{ required: false }"  :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">No </label>
                                    </div>
                                    
                                   
                                    

                                    <!--<b-form-checkbox :id="'contract_field_date_range_'+fixed_component.id"  v-model="component_values[fixed_component.field_key]" :name="'contract_field_date_range_'+fixed_component.id" value="1" unchecked-value="0" v-validate="{ required: false }" @input="setDateRangeValue(fixed_component.field_key,$event)" :disabled="isContractDisabled()">
                                        {{fixed_component.field_title}}
                                    </b-form-checkbox>-->
                                </b-form-group>
                                <b-form-group :id="fixed_component.field_key+'start-group'" label="Start Date" :label-for="fixed_component.field_key+'_start_date'" v-if="component_values[fixed_component.field_name] == 1">
                                    <b-form-datepicker :id="fixed_component.field_key+'_start_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].start.id" v-model="component_values[fixed_component.field_key+'_start_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                </b-form-group>
                                
                                
                                <b-form-group :id="fixed_component.field_key+'end-group'" label="End Date" :label-for="fixed_component.field_key+'_end_date'" v-if="component_values[fixed_component.field_name] == 1">
                                    <b-form-datepicker :id="fixed_component.field_key+'_end_date'" :name="'contract_field_date_type_'+salary_settings.reserved_data[fixed_component.field_key].end.id" v-model="component_values[fixed_component.field_key+'_end_date']" :disabled="isContractDisabled()" reset-button></b-form-datepicker>
                                </b-form-group>
                                
                                
                                 <b-form-group v-if="component_values['rent_free_accommodation']==1" id="rental_amount-group" label="Monthly Rental Amount" label-for="rental_amount">
                                    <b-form-input class="text-right max-200 " id="rental_amount" name="rental_amount" v-model="fdata.rental_amount" v-validate="{ required: false }" :state="validateState('rental_amount')" aria-describedby="rental_amount-feedback" data-vv-as="Monthly Rental Amount" @input="triggerProbationGrossChange()" :disabled="isContractDisabled()"></b-form-input>
                                    <b-form-invalid-feedback id="rental_amount-feedback">{{ veeErrors.first('rental_amount') }}</b-form-invalid-feedback>
                                 </b-form-group>
                       
                              </template>
                          </template>
                          <div class="clearfix mb-2 pb-2 mt-3"><div class="col-md-6 float-left pl-0"><b-button type="button" variant="primary" @click="goBack()">Prev</b-button></div><div class="col-md-6 float-right text-right pr-0"><b-button type="submit" variant="success" v-if="update_contract != 0" class="mr-3">Save</b-button><b-button type="button" variant="primary" @click="moveNext('2')">Next</b-button></div></div>
                        </tab-content>
                        <tab-content title="Any Non-Taxable Monthly Allowance" ref="tab_nontext_allowance">
                         <template v-for="(fixed_component,index)  in salary_settings.fixed">
                          <template v-if="fixed_component.field_key == 'other_non_taxable_monthly_allowance' && fixed_component.child_components">
                                <b-form-group label="Any Non-Taxable Monthly Allowance?" :label-for="fixed_component.field_key" class="my-2 custom-radio clearfix">
                                   <div class="custom-control float-left mr-3">
                                     <input type="radio" id="non_ml_yes" class="custom-control-input"  name="nontaxable_monthly_allowance_check" value="1" v-model="nontaxable_m_allowence"  :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">Yes </label>
                                   </div>
                                   <div class="custom-control float-left">
                                     <input type="radio" id="non_ml_no" class="custom-control-input"  name="nontaxable_monthly_allowance_check" value="0" v-model="nontaxable_m_allowence" :disabled="isContractDisabled()"/>
                                     <label class="custom-control-label">No </label>
                                   </div>
                                    <b-button v-if="nontaxable_m_allowence=='1'" variant="primary" id="show-btn" @click="selectChildComponents(fixed_component.field_name,fixed_component.field_title)" :disabled="isContractDisabled()" class="float-right pt-1 pl-1 pb-1"><b-icon icon="plus" type="is-primary" variant="" scale="1"></b-icon> Add / Update</b-button>
                                </b-form-group>
                                 <template v-if="nontaxable_m_allowence =='1'">
                                  <template v-if="fixed_component.child_components">
                                     <template v-for="fixed_child  in fixed_component.child_components">
                                        <b-form-group v-if="fixed_child.is_checked == 1"  :label="fixed_child.field_title" :label-for="fixed_child.field_key" class="clearfix">
                                            <b-form-input class="text-right max-200 " :id="fixed_child.field_key" :name="'contract_field_'+fixed_child.id" v-model="component_values[fixed_child.field_key]"  v-validate="{ required: false }"  :aria-describedby="'contract_field_'+fixed_child.id+'-feedback'" :data-vv-as="fixed_child.field_title" :disabled="isContractDisabled()"></b-form-input>
                                            <b-form-invalid-feedback :id="'contract_field_'+fixed_child.id+'-feedback'">{{ veeErrors.first('contract_field_'+fixed_child.id) }}</b-form-invalid-feedback>
                                        </b-form-group>
                                     </template>
                                  </template>
                                </template>
                            </template>
                            <template v-else-if="fixed_component.field_key == 'other_non_taxable_monthly_allowance'">
                            <p>Any Non-Taxable Monthly Allowance is not available for this company. Please add some fields from company payment settings first if you want to add any field here.</p>
                            </template>
                         </template>
                         <div class="clearfix mb-2 pb-2 mt-3"><div class="col-md-6 float-left ml-0 pl-0"><b-button type="button" variant="primary" @click="goBack()">Prev</b-button></div><div class="col-md-6 float-right text-right pr-0"><b-button type="submit" variant="success" v-if="update_contract != 0" class="mr-3">Save</b-button><b-button type="button" variant="primary" @click="moveNext()">Next</b-button></div></div>
                        </tab-content>
                        
                        <tab-content title="Any post-gross deduction" ref="tab_post_deduction">
                         <template v-for="(fixed_deduction,index)  in salary_settings.fixed_deduction">
                         <template v-if="fixed_deduction.field_key == 'other_post_gross_deduction' && fixed_deduction.child_components">
                          <b-form-group v-if="fixed_deduction.section_only != 1"  :label="fixed_deduction.field_title" :label-for="fixed_deduction.field_key">
                                <b-form-input class="text-right max-200 " :id="fixed_deduction.field_key" :name="'contract_field_'+fixed_deduction.id" v-model="component_values[fixed_deduction.field_name]" v-validate="{ required: false }"  :aria-describedby="'contract_field_'+fixed_deduction.id+'-feedback'" :data-vv-as="fixed_deduction.field_title" :disabled="isContractDisabled()"></b-form-input>
                                <b-form-invalid-feedback :id="'contract_field_'+fixed_deduction.id+'-feedback'">{{ veeErrors.first('contract_field_'+fixed_deduction.id) }}</b-form-invalid-feedback>
                            </b-form-group>
                            
                            <b-form-group v-else  label="Any post-gross deduction?" :label-for="fixed_deduction.field_key"  class="my-2 custom-radio clearfix">
                                <div class="custom-control float-left mr-3">
                                 <input type="radio" id="post_gd_yes" class="custom-control-input"  name="post_gross_deduction_check" value="1" v-model="post_gd"  :disabled="isContractDisabled()"/>
                                 <label class="custom-control-label">Yes </label>
                                </div>
                                <div class="custom-control float-left">
                                 <input type="radio" id="post_gd_no" class="custom-control-input" name="post_gross_deduction_check" value="0" v-model="post_gd" :disabled="isContractDisabled()"/>
                                 <label class="custom-control-label">No </label>
                                </div>
                                <b-button v-if="post_gd=='1'" :id="'show-btn'+fixed_deduction.field_name" variant="primary" @click="selectChildComponents(fixed_deduction.field_name,fixed_deduction.field_title)" :disabled="isContractDisabled()" class="float-right pt-1 pl-1 pb-1 pt-1 pl-1 pb-1"><b-icon icon="plus" type="is-primary" variant="" scale="1"></b-icon> Add / Update</b-button>
                            </b-form-group>
                            <template v-if="post_gd =='1'">
                            <template v-if="fixed_deduction.child_components">
                                 <template v-for="fixed_deduction_child  in fixed_deduction.child_components">
                                    <b-form-group v-if="fixed_deduction_child.is_checked == 1"  :label="fixed_deduction_child.field_title" :label-for="fixed_deduction_child.field_key" class="clearfix">
                                        <b-form-input class="text-right max-200 " :id="fixed_deduction_child.field_key" :name="'contract_field_'+fixed_deduction_child.id" v-model="component_values[fixed_deduction_child.field_key]"  v-validate="{ required: false }"  :aria-describedby="'contract_field_'+fixed_deduction_child.id+'-feedback'" :data-vv-as="fixed_deduction_child.field_title" :disabled="isContractDisabled()"></b-form-input>
                                        <b-form-invalid-feedback :id="'contract_field_'+fixed_deduction_child.id+'-feedback'">{{ veeErrors.first('contract_field_'+fixed_deduction_child.id) }}</b-form-invalid-feedback>
                                    </b-form-group>
                                 </template>
                                </template>
                              </template>
                           </template>
                           <template v-else-if="fixed_deduction.field_key == 'other_post_gross_deduction'">
                            <p>Any post-gross deduction is not available for this company. Please add some fields from company payment settings first if you want to add any field here.</p>
                            </template>
                         </template>
                         <div class="clearfix mb-2 pb-2 mt-3"><div class="col-md-6 float-left pl-0"><b-button type="button" variant="primary" @click="goBack()">Prev</b-button></div><div class="col-md-6 float-right text-right pr-0"><b-button type="submit" variant="success" >Save &amp; Finish</b-button></div></div>
                        </tab-content>
                    </form-wizard>
               </template>
            </b-card>
          </b-form>
        </div>
        <b-modal id="bv-modal-select-other-components" hide-footer :title="child_popup_title+'s'">        
                    

            <b-form @submit.stop.prevent="popupSubmit">
           
            <table class="table">
                        <thead>
                            <tr class="table-head">    
                                <th>Select</th>                
                                <th>Component</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="child_popup_components">
                            <input type="hidden" name="p_field_key" :value="child_popup_key">
                             <tr class="table-row hover-bg" v-for="ch_popup_data  in child_popup_components" :key="ch_popup_data.id"> 
                               <td>
                                <b-form-group :id="'probation_period-group-'+ch_popup_data.id">
                                <b-form-checkbox :id="'field_'+ch_popup_data.id"  v-model="child_component_data[ch_popup_data.id]" :name="'field_'+ch_popup_data.id+'_'+ch_popup_data.field_key" v-validate="{ required: false }"  value="1" unchecked-value="0">
                                    <!--State: <strong>{{ child_component_data[ch_popup_data.id] }}</strong>-->
                                </b-form-checkbox>
                                </b-form-group>
                                </td>
                                 <td>{{ch_popup_data.field_title}}</td>
                              </tr>
                            </template>
                        </tbody>
                        <tfoot>
                        <tr class=""><td class="px-0" colspan="2">
                                <div class="d-flex justify-content-center font-weight-bold">
                                <button type="submit" class="btn btn-success btn-full-width">Save</button>
                                </div></td></tr>
                        </tfoot>
                    </table>
           </b-form>   
     </b-modal>
    
    </div>
    </b-overlay>
</template>

<style scoped>
  .active-bg {
    background-color: #E5FFF9 !important;
  }
  .custom-info{background: #f0f0f0;color: #585858;}
  .dashed-border{border-bottom: 1px dashed #000;}
  .custom-control-input{z-index: 11;}
</style>

<script>

    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    export default{
        
        mounted() {
        }, 
        
        computed: {
        },
      
        props: ['contract_id','employee_id'],
        components: {
           FormWizard,  TabContent,
        },
        data(){
            return {  
                contract: [],
                fdata: [],
                update_contract: 0,
                contract_lists: [],
                review_contract: 0,
                salary_settings: [],
                component_values: [],
                child_component_values: [],
                probation_salary: [],
                child_popup_title: '',
                child_popup_key: '',
                child_popup_components: [],
                child_component_data: [],
                optimize_fields : {house_rent: '0',conveyance_allowance: '0',medical_allowance: '0'},
                skip_optimization: 0,
                status: 1,
                trzsuccess: '',
                trzerrormsg:'',
                errormsg:[],
                loopidxtest: 0,
                successmsg:'',
                contract_action:'activate',
                other_m_allowence: 0,
                nontaxable_m_allowence: 0,
                post_gd: 0,
                pf_entitlement: 0,
                update_wizard: 0,
                wizard_options:[{value: 0, text: "Update effective date" },{value: 1, text: "Salary Information"},{value: 1, text: "Other monthly allowance"},{value: 2, text: "Other non-taxable monthly allowance"},{value: 3, text: "Post-gross deduction"}],
                showoverlay : false,
                last_payslip_date: '',
                monthNames : ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"],
                pb_salary_fields_editable: 1,
                salary_fields_editable: 1,
                
                 
            }
        },
        
       watch: {
        contract_id() {
          this.loadContractInfo();
        }
       },
        
        methods:{            

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
            moneyFormat(amount)
            {
              if(amount && parseFloat(amount)>0){
                return amount.toLocaleString();
              }
            },
            
            isContractDisabled(){
                return false;
            },
            
            checkGrossSalary(field_key){
              var optimize_salary_fields = ['basic_salary','house_rent','conveyance_allowance','medical_allowance'];
              var curr_gross = 0;
              if(optimize_salary_fields.includes(field_key)){
                for (var f_key in optimize_salary_fields) {
                    if(this.component_values[optimize_salary_fields[f_key]]){
                     curr_gross = curr_gross + parseFloat(this.component_values[optimize_salary_fields[f_key]]);
                    }
                }
                if(curr_gross > 0)
                this.fdata.gross = curr_gross;
                this.fdata.gross_display = this.moneyFormat(curr_gross);
              }
            },
            
            validateFormOverview: function(){
                let errors = [];
                let user_dis_name = 'this user';
                if(this.contract.employee_name && this.contract.employee_name.length>0)
                user_dis_name = this.contract.employee_name;
                
                //if(!this.update_contract){
                //if(!this.fdata.contract_start || (new Date(this.fdata.contract_start) - new Date() < - 86400000 ))
                if(!this.fdata.contract_start)
                errors.push('Please enter a valid contract start date'); 
                //}
                
                if(this.last_payslip_date){
                  let date_payrun = new Date(Date.parse(this.last_payslip_date));
                  let date_contract_start = new Date(this.fdata.contract_start);
                  let contract_start_date_error = false;
                  //errors.push(date_payrun+date_payrun.getMonth());
                  //errors.push('Contract start date can not be prior to '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' since this company has an Draft / Approved Payrun created until  '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear());
                  if(date_contract_start.getFullYear() < date_payrun.getFullYear())
                  contract_start_date_error = true;
                  else if(date_contract_start.getFullYear() == date_payrun.getFullYear()){
                    if(date_contract_start.getMonth() <= date_payrun.getMonth())
                    contract_start_date_error = true;
                  }
                  
                  if(contract_start_date_error)
                  errors.push('Contract start date can not be prior to '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' since '+user_dis_name+' has an Draft / Approved Payslip created under  '+this.monthNames[date_payrun.getMonth()]+' - '+date_payrun.getFullYear()+' Payrun.'); 
                }
                
                
                if(this.fdata.contract_end && (new Date(this.fdata.contract_end) < new Date(this.fdata.contract_start))){
                    errors.push('Contract end date should be greater than contract start date'); 
                }
                
                if(parseInt(this.fdata.has_probation) == 1){
                  if(!this.fdata.probation_start)
                  errors.push('Please enter probation period start date');
                  
                  if(this.fdata.pb_optimized_salary_for_max_benefit !=0 && this.fdata.pb_optimized_salary_for_max_benefit !=1)
                  errors.push('Please select whether you want to optimize salary or enter manually');
                  
                  if(!this.validateProbationSalaryFields())
                  return false;
                  
                  
                }
                
                if(parseInt(this.pf_entitlement) == 1){
                  if(!this.fdata.pf_start)
                  errors.push('Please enter PF entitlement start date');
                }
                
                
                
                
                if(errors.length >0){
                this.$bvToast.toast(errors[0], {title: 'Error!!!',variant: 'danger',solid: true});
                return false;
                }
                else
                return true;
            },
            
            loadWizard:function(){
              this.$refs.wizard.changeTab(0,this.update_wizard);   
            },
            moveNext: function(step=''){
                /*this.$bvToast.toast("Step: "+step, {title: 'Error!',variant: 'danger',solid: true});*/
                if(step=='1'){
                  if(this.validateFormOverview())
                  this.$refs.wizard.nextTab();
                }else if(step=='2'){
                  if(this.validateSalaryFields())
                  this.$refs.wizard.nextTab();
                }else{
                   this.$refs.wizard.nextTab(); 
                }
            },
            goBack: function(){
             this.$refs.wizard.prevTab();
            },
            
            
            onComplete: function(){
                
                /*this.$bvToast.toast('Yay. Done!', {
                                            title: `All steps completed`,
                                            variant: 'success',
                                            solid: true
                                        });


                location.reload(); */
                
                //this.$refs.wizard.submit();
            },
            checkProbationGrossSalary(field_key){
              var optimize_salary_fields = ['probation_basic_salary','probation_house_rent','probation_conveyance_allowance','probation_medical_allowance'];
              var curr_gross = 0;
              if(optimize_salary_fields.includes(field_key)){
                for (var f_key in optimize_salary_fields) {
                    if(this.probation_salary[optimize_salary_fields[f_key]] && f_key !='probation_gross_salary'){
                     curr_gross = curr_gross + parseFloat(this.probation_salary[optimize_salary_fields[f_key]]);
                    }
                }
                if(curr_gross > 0)
                this.probation_salary['probation_gross_salary'] = curr_gross;                
              }
            }, 
            setChildComponents(parent_key,child_data){
                //console.log("parent_key");
                if(parent_key && child_data){
                    console.log(parent_key);
                    this.child_component_values[parent_key] = child_data;
                    for (var c_data in child_data) {
                        
                        this.component_values[child_data[c_data].field_key] = child_data[c_data].field_value;
                        if(parent_key =='other_monthly_allowance' && parseFloat(child_data[c_data].field_value)>0)
                        this.other_m_allowence = 1;
                        else if(parent_key =='other_non_taxable_monthly_allowance' && parseFloat(child_data[c_data].field_value)>0)
                        this.nontaxable_m_allowence = 1;
                        else if(parent_key =='other_post_gross_deduction' && parseFloat(child_data[c_data].field_value)>0)
                        this.post_gd = 1;
                        
                    }
                }
            },
            setComponentValues: function()
            {
                //this.loopidxtest++;
                //console.log('setComponentValues call '+this.loopidxtest);
                
                if(this.salary_settings.fixed.length>0){
                    var optimize_fields_array = ['house_rent','conveyance_allowance','medical_allowance'];
                    
                    for (var c_data in this.salary_settings.fixed) {
                      if(parseInt(this.salary_settings.fixed[c_data].date_range) != 1)
                      this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].field_value;
                      else
                      this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].is_checked;
                      
                      if(optimize_fields_array.includes(this.salary_settings.fixed[c_data].field_name))
                      this.optimize_fields[this.salary_settings.fixed[c_data].field_name] = '1';
                      
                      if(parseInt(this.salary_settings.fixed[c_data].section_only)>0){
                        if(this.salary_settings.fixed[c_data].child_components)
                        this.setChildComponents(this.salary_settings.fixed[c_data].field_name, this.salary_settings.fixed[c_data].child_components);
                      }
                    }
                }
                
                if(this.salary_settings.fixed_deduction.length>0){
                    for (var m_data in this.salary_settings.fixed_deduction) {
                      
                      this.component_values[this.salary_settings.fixed_deduction[m_data].field_name] = this.salary_settings.fixed_deduction[m_data].field_value;
                      if(parseInt(this.salary_settings.fixed_deduction[m_data].section_only)>0){
                        if(this.salary_settings.fixed_deduction[m_data].child_components)
                        this.setChildComponents(this.salary_settings.fixed_deduction[m_data].field_name, this.salary_settings.fixed_deduction[m_data].child_components);
                      }
                    }
                }
                //console.log('Comes here');
                if(this.salary_settings.reserved_data){
                    //console.log('Enter Comes here');
                    for (var r_data in this.salary_settings.reserved_data) {
                      if(!this.salary_settings.reserved_data[r_data].start){
                      if(this.salary_settings.reserved_data[r_data].field_key){
                        
                      if(this.salary_settings.reserved_data[r_data].field_key.indexOf("_date")>0){
                        if(this.salary_settings.reserved_data[r_data].field_value !='0000-00-00')
                        this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
                        else
                        this.component_values[this.salary_settings.reserved_data[r_data].field_key] = "";
                      }else{
                       this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
                       }
                      }//console.log('Field Key: '+this.salary_settings.reserved_data[r_data].field_key+', Field Value: '+this.salary_settings.reserved_data[r_data].field_value);
                      //console.log(this.salary_settings.reserved_data[r_data].field_key);
                       if(this.salary_settings.reserved_data[r_data].field_key =='rent_free_accommodation_start_date' && this.salary_settings.reserved_data[r_data].field_value !='')
                       this.component_values['rent_free_accommodation'] = 1;
                       else if(this.salary_settings.reserved_data[r_data].field_key =='conveyance_personal_private_start_date' && this.salary_settings.reserved_data[r_data].field_value !='')
                       this.component_values['conveyance_personal_private'] = 1;
                       
                       
                      }
                    }
                   this.fdata.gross = this.salary_settings.reserved_data.gross_salary.field_value; 
                   this.fdata.gross_display = this.moneyFormat(this.salary_settings.reserved_data.gross_salary.field_value); 
                   this.fdata.rental_amount = this.salary_settings.reserved_data.rental_amount.field_value; 
                }
                
                if(this.salary_settings.probation_data){
                    //console.log('Enter Comes here');
                    for (var p_data in this.salary_settings.probation_data) {
                      if(this.salary_settings.probation_data[p_data].field_key)
                      this.probation_salary[this.salary_settings.probation_data[p_data].field_key] = this.salary_settings.probation_data[p_data].field_value;
                      //console.log('Field Key: '+this.salary_settings.probation_data[p_data].field_key+', Field Value: '+this.salary_settings.probation_data[p_data].field_value);
                    }
                } 
            },
            
            
            getContractLists: function()
            {

                   axios.get(this.$api_url+'/front/allcontracts', {
                            params: {
                            }
                    }).then(function(response){
                    this.contract_lists = response.data.data;
                    //console.log(response.data.data);
                }.bind(this))
                .catch(function (error) 
                            {
                                currentObj.errormsg = error.response.data.errors;
                });
            },
            
            getSalarySettings: function()
            {
                axios.get(this.$api_url+'/front/employeesalarysettings/'+this.contract.employee_id +'/'+this.contract.id, {
                            params: {
                            }
                    }).then(function(response){
                    this.salary_settings = response.data.data;
                    this.setComponentValues();  
                }.bind(this));
            },
            selectChildComponents(fieldKey, filedTitle) {
              if(this.child_component_values[fieldKey]){
                  var child_comp_val = 0;
                  for (var ch_data in this.child_component_values[fieldKey]) {
                        child_comp_val = parseInt(this.child_component_values[fieldKey][ch_data].is_checked) ? 1: 0;
                        this.child_component_data[this.child_component_values[fieldKey][ch_data].id] = child_comp_val;
                  }
                  this.child_popup_title = filedTitle;
                  this.child_popup_components = this.child_component_values[fieldKey];
                  this.child_popup_key = fieldKey;
                  this.$root.$emit('bv::show::modal', 'bv-modal-select-other-components');
              }else{
                this.$bvToast.toast("Please add component field for '"+filedTitle+"' from company settings.", {
                                            title: 'No components available',
                                            variant: 'danger',
                                            solid: true
                                        });
              }
              
            },

            setDateRangeValue(tKey,currVal) {
              
              if(parseInt(currVal) == 0){
                this.component_values[tKey+'_start_date'] = '';
                this.component_values[tKey+'_end_date'] = '';
              }  
              
            },
            
            triggerGrossChange() {
               if(this.fdata.optimized_salary_for_max_benefit == 1){
                this.optimizeSalary(1);
               }
            },
            triggerProbationGrossChange() {
               if(this.fdata.pb_optimized_salary_for_max_benefit == 1){
                this.optimizeProbationSalary(1);
               }
            },
            
            
            optimizeSalary(cVal) {
                this.salary_fields_editable = 0;
              if(parseInt(cVal) == 1) {
                if(parseInt(this.fdata.gross)<999 || !this.fdata.gross){
                   //this.errormsg['0'] = ["Enter valid gross salary"];
                   this.$bvToast.toast("Please enter valid gross salary", {
                                            title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        }); 
                }else{
                    let currentObj = this;
                    this.errormsg.splice(0, 1);
                    //console.log("Optimize Salary Fields: House Rent => " +this.optimize_fields.house_rent+" Conveyance => "+this.optimize_fields.conveyance_allowance+" Medical => "+this.optimize_fields.medical_allowance);
                    const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                if(parseInt(this.optimize_fields.house_rent) || parseInt(this.optimize_fields.conveyance_allowance) || parseInt(this.optimize_fields.medical_allowance)){
                    let formData = new FormData();
                   
                    formData.append('gross_salary', this.fdata.gross);
                    formData.append('medical', this.optimize_fields.medical_allowance);
                    formData.append('conv', this.optimize_fields.conveyance_allowance);
                    formData.append('hra', this.optimize_fields.house_rent);
                    
                    
                    
                    axios.post(this.$api_url + '/optimizesalary', formData, config)
                            .then(function (response) 
                            {
                                if(response.data.data){
                                   for (var res_data in response.data.data) {
                                     if(response.data.data[res_data]){
                                     this.component_values[res_data] = response.data.data[res_data];
                                     this.$set(this.component_values,0,true);
                                     }
                                   }
                                }
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.errormsg = error.response.data.errors;
                            }); 

                    
                }
                else{
                   this.$bvToast.toast("For salary optimization you have to enable at lease 1 field from 'House Rent Allowance/Conveyance Allowance/Medical Allowance' in 'Company Salary Settings'", {
                                            title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });    
                }
                }
              }
              else
              this.errormsg.splice(0, 1);
            },
            
            optimizeProbationSalary(cVal) {
                                        
              this.pb_salary_fields_editable = 0;
              if(parseInt(cVal) == 1) {
                if(parseInt(this.probation_salary['probation_gross_salary'])<999 || !this.probation_salary['probation_gross_salary']){
                   this.$bvToast.toast("Please enter valid probation gross salary", {
                                            title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        }); 
                }else{
                    let currentObj = this;
                    this.errormsg.splice(0, 1);
                    const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                if(parseInt(this.optimize_fields.house_rent) || parseInt(this.optimize_fields.conveyance_allowance) || parseInt(this.optimize_fields.medical_allowance)){
                    let formData = new FormData();
                    
                    formData.append('gross_salary', this.probation_salary['probation_gross_salary']);
                    formData.append('medical', this.optimize_fields.medical_allowance);
                    formData.append('conv', this.optimize_fields.conveyance_allowance);
                    formData.append('hra', this.optimize_fields.house_rent);
                    
                    axios.post(this.$api_url + '/optimizesalary', formData, config)
                            .then(function (response) 
                            {
                                if(response.data.data){
                                   for (var res_data in response.data.data) {
                                     if(response.data.data[res_data]){
                                     this.probation_salary['probation_'+res_data] = response.data.data[res_data];
                                     this.$set(this.probation_salary,0,true);
                                     this.$delete(this.probation_salary, 0);
                                     }
                                   }
                                }
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.errormsg = error.response.data.errors;
                            }); 

                    
                }
                else{
                   this.$bvToast.toast("For salary optimization you have to enable at lease 1 field from 'House Rent Allowance/Conveyance Allowance/Medical Allowance' in 'Company Salary Settings'", {
                                            title: 'Error!',
                                            variant: 'danger',
                                            solid: true
                                        });    
                }
                }
              }
              else
              this.errormsg.splice(0, 1);
            },
            
            initializeContractDates: function()
            {
            if(this.contract.probation_start == '0000-00-00')
                this.fdata.probation_start = '';
            if(this.contract.probation_end == '0000-00-00')
                this.fdata.probation_end = '';
            if(this.contract.contract_start == '0000-00-00')
                this.fdata.contract_start = '';
            if(this.contract.contract_end == '0000-00-00')
            this.fdata.contract_end = '';
            if(this.contract.pf_start == '0000-00-00')
            this.fdata.pf_start = '';
            else if(this.contract.pf_start != '')
            this.pf_entitlement = 1;
            },

            addNewContract: function()
            {

                   axios.get(this.$api_url+'/front/addcontract/'+this.contract.employee_id, {
                            params: {
                            }
                    }).then(function(response){
                    if(response.data.contract_id){
                        window.location.href = this.$api_url+'/front/contract/'+this.contract.employee_id+'/'+response.data.contract_id;
                    }

                }.bind(this));
            },
            
            popupSubmit(e) 
            {
                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                
                let request_data = null;
                let submit_data = false;
                
                for (let item in e.target){
            
                  if (e.target.hasOwnProperty(item)){
                     const record = e.target[item];
                     if(record.name){
                        if(record.name == 'p_field_key')
                        formData.append(record.name,record.value);
                        else{
                        request_data = record.checked ? 1: 0;
                        formData.append(record.name,request_data);
                        submit_data = true;
                        }
                     }
                  }
                }
             if(submit_data){
                
             formData.append('employee_id', this.contract.employee_id);  
             formData.append('contract_id', this.contract.id);
             
             axios.post(this.$api_url+'/front/savechildcomponents', formData, config)
                            .then(function (response) 
                            {
                                if(response.data.data){
                                  for (var f_key in response.data.data) {
                                    if(f_key){
                                        for (var f_id in response.data.data[f_key]) {
                                          this.child_component_values[f_key][f_id].is_checked = response.data.data[f_key][f_id].is_checked;
                                        }
                                    }
                                  } 
                                  
                                  this.$root.$emit('bv::hide::modal', 'bv-modal-select-other-components'); 
                                }
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.errormsg = error.response.data.errors;
                            });
              }
             
            },
            
            
            loadContractInfo(){
                //console.log('Here is contract id'+this.contract_id);
                if(parseInt(this.contract_id)>0){
                    this.showoverlay = true;
                    this.update_contract = this.contract_id;
                    axios.get(this.$api_url+'/front/getcontractinfo/'+this.contract_id, {
                                params: {
                                }
                        }).then(function(response){
                        if(response.data.data){
                           this.contract = response.data.data;
                           this.fdata = response.data.data;
                           this.getSalarySettings();
                           this.initializeContractDates();
                           this.fdata.pb_optimized_salary_for_max_benefit = 0;
                           this.fdata.optimized_salary_for_max_benefit = 0; 
                           this.showoverlay = false;
                        }
                    }.bind(this));
                    
                }else{
                    this.showoverlay = true;
                    axios.get(this.$api_url+'/front/getnewcontract', {
                            params: {
                                employee_id: this.employee_id
                            }
                    }).then(function(response){
                    if(response.data.data){
                       this.contract = response.data.data;
                       this.fdata = response.data.data;
                       this.getSalarySettings();
                       this.initializeContractDates();
                       this.showoverlay = false;
                    }
                  }.bind(this)); 
                }
            },
            
            
            loadGeneralSettings(){
              axios.get(this.$api_url+'/front/get_employee_last_payslip_date', {
                                params: {
                                }
                        }).then(function(response){
                        //alert(); 
                        //console.log(response.data);  
                        if(response.data){
                         this.last_payslip_date =  response.data; 
                        }else{
                          this.last_payslip_date = '';  
                        }
                        
               }.bind(this));
            },
            triggerNewContract(){
              this.review_contract = 0;
              this.skip_optimization = 0;
              axios.get(this.$api_url+'/front/getnewcontract', {
                            params: {
                                employee_id: this.employee_id
                            }
                    }).then(function(response){
                    if(response.data.data){
                       this.contract = response.data.data;
                       this.fdata = response.data.data;
                       this.getSalarySettings();
                       this.initializeContractDates();
                    }
                }.bind(this));
            },
            
            triggerContractArchive(){
              this.review_contract = 0;
            },
            
            validateSalaryFields(){
              var optimize_salary_fields = ['basic_salary','house_rent','conveyance_allowance','medical_allowance'];
              var curr_gross = 0;
              
              if(!parseFloat(this.fdata.gross)){
                this.$bvToast.toast("Please enter valid Gross Salary", {title: 'Error!',variant: 'danger',solid: true});
                return false;
              }
              
              if(this.fdata.optimized_salary_for_max_benefit !=0 && this.fdata.optimized_salary_for_max_benefit !=1){
                this.$bvToast.toast("Please select whether you want to optimize salary or enter manually", {title: 'Error!',variant: 'danger',solid: true});
              return false;
              }
              
              
              for (var f_key in optimize_salary_fields) {
                    if(this.component_values[optimize_salary_fields[f_key]]){
                     curr_gross = curr_gross + parseFloat(this.component_values[optimize_salary_fields[f_key]]);
                    }
              }
              if(parseFloat(this.fdata.gross) != parseFloat(curr_gross)){
                this.$bvToast.toast("Total Salary "+curr_gross+ " not equal to Gross Salary "+this.fdata.gross, {title: 'Error!',variant: 'danger',solid: true});
                return false;
              }else{
                return true;
              }
            },
            validateProbationSalaryFields(){
              var optimize_probation_salary_fields = ['probation_basic_salary','probation_house_rent','probation_conveyance_allowance','probation_medical_allowance'];
              var p_curr_gross = 0;
              
              if(this.fdata.has_probation == 1){
                if(!parseFloat(this.probation_salary['probation_gross_salary'])){this.$bvToast.toast("Please enter a valid Probation Gross Salary", {title: 'Error!',variant: 'danger',solid: true});
                 return false;
                }
              }

             if(this.fdata.has_probation == 1){
                   for (var pf_key in optimize_probation_salary_fields) {
                    if(this.probation_salary[optimize_probation_salary_fields[pf_key]]){
                     p_curr_gross = p_curr_gross + parseFloat(this.probation_salary[optimize_probation_salary_fields[pf_key]]);
                    }
                  }
                  if(parseFloat(this.probation_salary['probation_gross_salary']) != parseFloat(p_curr_gross)){
                    this.$bvToast.toast("Total Probation Salary "+p_curr_gross+ " is not equal to Probation Gross Salary "+this.probation_salary['probation_gross_salary'], {title: 'Error!',variant: 'danger',solid: true});
                    return false; 
                    }
             }
             return true; 
            },
            
            saveContractData(formData,config)
            {
                   let currentObj = this;
                   axios.post(this.$api_url+'/front/savecontract', formData, config)
                            .then(function (response) 
                            {                            
                                currentObj.successmsg = response.data.message;
                                if(response.data.success){
                                    this.$bvToast.toast(response.data.message, {
                                            title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                                    //this.getContractLists();
                                    this.$emit('event','success');
                                }
                                 
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.errormsg = error.response.data.errors;
                                this.$bvToast.toast(error.response.data.errors, {
                                            title: 'Error',
                                            variant: 'danger',
                                            solid: true
                                        });
                            });
                   
            },
            
            
            
            onSubmit:function(e) 
            {
                
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                
                e.preventDefault();
                let currentObj = this;
                
                if(this.validateSalaryFields()){
                let data_val = null;
                let pb_optimization = false;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }
                let formData = new FormData();
                
                for (let item in e.target){
                  if (e.target.hasOwnProperty(item)){
                     const record = e.target[item];
                     if(record.name){
                        if(record.type=='checkbox')
                        data_val = record.checked ? 1: 0;
                        else if(record.type=='radio'){
                            if(record.checked)
                            data_val = record.value;
                            else
                            continue;
                        }
                        else
                        data_val = record.value;
                        formData.append(record.name,data_val);
                     }
                  }
                }
               
                formData.append('employee_id', this.contract.employee_id);  
                formData.append('contract_id', this.contract.id);
                formData.append('contract_status', this.contract_action);
                formData.append('contract_field_'+this.salary_settings.reserved_data.gross_salary.id, this.fdata.gross);
                if(this.fdata.has_probation)
                formData.append('contract_field_'+this.salary_settings.reserved_data.probation_gross_salary.id, this.probation_salary['probation_gross_salary']);
                
                if(this.component_values['rent_free_accommodation']==1){
                if(this.fdata.rental_amount){
                   formData.append('contract_field_'+this.salary_settings.reserved_data.rental_amount.id, this.fdata.rental_amount);
                   formData.append('rental_amount'+this.salary_settings.reserved_data.rental_amount.id, this.fdata.rental_amount);
                }
                }
                
                
                if(this.validateFormOverview()){
                  if(!this.validateSalaryFields()){
                    this.$refs.wizard.changeTab(0,1);
                    return false;
                  }
                    
                }else{
                    this.$refs.wizard.changeTab(0,0);
                    return false;
                }
                
                if(this.contract_action =='activate'){
                    
                this.$bvModal.msgBoxConfirm('Saving this contract will create a new active contract and will end the last active contract irrespective of whether end date is provided or not. Do you want to continue?', {title: 'Confirm contract saving', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false,centered: true})
.then(value => {                    
                    if(value)
                    {                        
                        this.saveContractData(formData,config);
                        this.$refs.wizard.changeTab(0,0);
                    }
                })
                .catch(err => {
                    // An error occurred
                    });
                    
                }else{
                    this.saveContractData(formData,config);
                    this.$refs.wizard.changeTab(0,0);
                 }
                }
                });
            },
            
            createMask: function(string)
            {
                string = this.moneyFormat(string);
                return string;
            },
            
            destroyMask: function(string){
                return string.replace(/\,/g,'');
            },
            
            changeMoneyFormate: function(value)
            {
                this.fdata.gross_display = this.moneyFormat(value);
                this.fdata.gross = value.replace(/\,/g,'');
            }     
        },
        created: function(){
            this.loadGeneralSettings();
            this.loadContractInfo();
            
         //this.getContractLists(); 
        }
    }
</script>